export default __webpack_public_path__ + "media/images/amenities/coin_laundry-2d394a175aed014ba810d1e5aac8fc5f.jpeg";